export enum ListView {
  GALLERY= 'gallery',
  LIST = 'list',
  SEARCH = 'search'
}
